<template>
  <b-modal
    id="cmd_config_modal"
    ref="cmd_config_modal"
    title="Command Config"
    @show="onShow"
    @hidden="resetDataModal"
    hide-header
    centered
    no-close-on-esc
    no-close-on-backdrop
    scrollable
  >
    <p class="h3 mb-0">{{ $t('commands.config_modal.title') }}</p>
    <hr class="mb-2" />
    <node-data
      ref="nodeData"
      :node-info="currentNodeInfo"
      :requirements="currentNodeRequirements"
      :flowchart-config="flowchartConfig"
      v-model="model"
    ></node-data>
    <template v-if="formHasErrors">
      <hr />
      <p class="text-danger">
        {{ $t('commands.config_modal.messages.invalid_form') }}
      </p>
    </template>
    <hr />
    <div class="cmd-chart-option" v-if="chartTypeOptions">
      <p class="mb-1 font-weight-bold">
        {{ $t('commands.config_modal.chart.label') }}
      </p>
      <b-form-select
        v-model="model.chart_type"
        :options="chartTypeOptions"
        size="sm"
      />
      <small class="text-muted d-block mt-50">
        {{ $t('commands.config_modal.chart.hint') }}
      </small>
    </div>

    <template #modal-footer="{ close }">
      <div class="">
        <b-button variant="danger" size="sm" class="float-left mr-1" @click="close()">
          {{ $t("commands.modal.btns.cancel") }}
        </b-button>
        <b-button
          variant="primary"
          size="sm"
          class="float-right"
          @click="onContinueClick(close)"
        >
          {{ $t("commands.modal.btns.continue") }}
        </b-button>
      </div>
    </template>
  </b-modal>
</template>

<script>
import { BSpinner, BFormSelect } from "bootstrap-vue";
import NodeData from "@/components/flowchart/nodes/commands/NodeData";
import fields from "@/libs/CommandFields/fields";
import { isAssignOperationalFormTaskEditorContext } from "@/libs/assignOperationalFormTask";

export default {
  components: {
    BSpinner,
    BFormSelect,
    NodeData,
  },
  props: {
    currentNodeInfo: {
      type: Object,
      default: () => ({})
    },
    currentNodeRequirements: {
      type: Array,
      default: () => [],
    },
    flowchartConfig: {
      type: Object,
      default: () => ({}),
    },
    value: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      model: {},
      formHasErrors: false,
      fields,
    };
  },
  watch: {
    model: {
      deep: true,
      handler(val) {
        this.setCameraAssignmentRules(val);
      },
    },
  },
  computed: {
    chartTypeOptions() {
      return [
        { value: null, text: this.$t("commands.config_modal.chart.types.none") },
        { value: "bar", text: this.$t("commands.config_modal.chart.types.bar") },
        { value: "line", text: this.$t("commands.config_modal.chart.types.line") },
        { value: "pie", text: this.$t("commands.config_modal.chart.types.pie") },
        { value: "graph", text: this.$t("commands.config_modal.chart.types.graph") },
      ];
    },
  },
  methods: {
    onShow() {
      this.model = JSON.parse(JSON.stringify(this.value || {}));
    },
    async onContinueClick(close) {
      const nodeDataRefs = this.$refs.nodeData;
      let resultValidation = false;
      try {
        resultValidation = await nodeDataRefs.$refs.observer.validate();
      } catch (error) {
        console.error("CommandConfigModal: validation failed", error);
        resultValidation = false;
      }
      this.formHasErrors = !resultValidation;

      if (!this.formHasErrors) {
        this.formHasErrors = false;
        const isAssignFormTask = isAssignOperationalFormTaskEditorContext(
          this.currentNodeInfo,
          this.currentNodeRequirements
        );
        let payload = this.model;
        if (isAssignFormTask) {
          payload = { ...this.model };
          delete payload.users;
        }
        this.$emit("input", payload);
        close();
      }
    },
    resetDataModal() {
      this.model = {};
      this.formHasErrors = false;
    },
    setCameraAssignmentRules(val) {
      if (val) {

        if (this.model.users) {
          if (this.model.users.length > 0) {
            this.fields.groups.rules = null;
          } else {
            this.fields.groups.rules = "required";
            this.fields.users.rules = "required";
          }
        }

        if (this.model.groups) {
          if (this.model.groups.length > 0) {
            this.fields.users.rules = null;
          }
        }

        if (this.model.tenants) {
          if (this.model.tenants.length > 0) {
            this.fields.centers.rules = null;
            this.fields.sectors.rules = null;
          } else {
            this.fields.centers.rules = "required";
            this.fields.sectors.rules = "required";
          }
        }

        if (this.model.centers) {
          if (this.model.centers.length > 0) {
            this.fields.tenants.rules = null;
            this.fields.sectors.rules = null;
          } else {
            this.fields.tenants.rules = "required";
          }
        }

        if (this.model.sectors) {
          if (this.model.sectors.length > 0) {
            this.fields.tenants.rules = null;
            this.fields.centers.rules = null;
          }
        }
      }
    },
  },
};
</script>

<style></style>
